// extracted by mini-css-extract-plugin
export default {"dialog":"a8D_vfacv4UuNF8IihKR","fill":"eqDMkDq9PP0AqK8K4Ypu","inboxList":"_3dsuetfv2onTNmyozwW","inboxRow":"bJvZl7hzWzQoCT0wvCEm","dropCard":"qZqKv6hJvMIEend5opZ8"};